(function () {
  'use strict';

  var cache = {};       // handle -> compareAtPrice in cents
  var itemPrices = {};  // numeric productId -> compareAtPrice in cents

  function formatPrice(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  function numericId(gid) {
    return gid ? gid.split('/').pop() : null;
  }

  function getHandleFromLink(el) {
    for (var node = el.parentElement, i = 0; node && i < 10; node = node.parentElement, i++) {
      var link = node.querySelector('a[href*="/products/"]');
      if (link) {
        var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
        if (m) return m[1];
      }
    }
    return null;
  }

  function getCompareAtPrice(handle) {
    if (handle in cache) return Promise.resolve(cache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        cache[handle] = data.compare_at_price_min || 0;
        return cache[handle];
      })
      .catch(function () {
        cache[handle] = 0;
        return 0;
      });
  }

  // --- Product page ---

  function updateBundleTotal() {
    var allEls = document.querySelectorAll('.BC_bundle-product-price');
    if (!allEls.length) return;
    var allDone = Array.from(allEls).every(function (el) { return el.dataset.bcUpdated; });
    if (!allDone) return;
    var total = Object.values(itemPrices).reduce(function (sum, p) { return sum + p; }, 0);
    if (!total) return;
    var totalEl = document.querySelector('s.price-item.price-item--regular');
    if (totalEl) totalEl.textContent = formatPrice(total);
  }

  function updateBundleItem(el) {
    if (el.dataset.bcUpdated) return;
    el.dataset.bcUpdated = '1';

    var priceSpan = el.querySelector('.BC_sale-price') || el;
    var container = el.closest('[data-product-id]');
    if (!container) { delete el.dataset.bcUpdated; return; }

    var productId = numericId(container.dataset.productId);
    var priceMap = window.__bcComparePrices;

    if (priceMap && priceMap[productId] !== undefined) {
      if (priceMap[productId]) {
        priceSpan.textContent = formatPrice(priceMap[productId]);
        itemPrices[productId] = priceMap[productId];
      }
      updateBundleTotal();
      return;
    }

    var link = container.querySelector('a[href*="/products/"]');
    if (!link) { delete el.dataset.bcUpdated; return; }
    var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    if (!m) { delete el.dataset.bcUpdated; return; }

    getCompareAtPrice(m[1]).then(function (price) {
      if (price) {
        priceSpan.textContent = formatPrice(price);
        itemPrices[productId] = price;
      }
      updateBundleTotal();
    });
  }

  function scanProductPage() {
    document.querySelectorAll('.BC_bundle-product-price:not([data-bc-updated])').forEach(updateBundleItem);
  }

  // --- Collection page ---

  function updateCollectionItem(el) {
    if (el.dataset.bcCollectionUpdated) return;

    var bundlePrices = window.__bcCollectionBundlePrices;
    if (!bundlePrices) return;

    var handle = getHandleFromLink(el);
    if (!handle || bundlePrices[handle] === undefined) return;

    el.dataset.bcCollectionUpdated = '1';
    var moneySpan = el.querySelector('.money');
    if (moneySpan && bundlePrices[handle]) {
      moneySpan.textContent = formatPrice(bundlePrices[handle]);
    }
  }

  function scanCollectionPage() {
    document.querySelectorAll('.sg__swatch-price-compare:not([data-bc-collection-updated])').forEach(updateCollectionItem);
  }

  // --- Init ---

  // Always observe for bundle items — BundleSuite renders .BC_bundle-product-price
  // asynchronously so element presence can't be checked at script run time
  scanProductPage();
  new MutationObserver(scanProductPage).observe(document.body, { childList: true, subtree: true });

  // Collection page: observe only if price map is present
  if (window.__bcCollectionBundlePrices !== undefined) {
    scanCollectionPage();
    new MutationObserver(scanCollectionPage).observe(document.body, { childList: true, subtree: true });
  }

})();
